<button
  type="button"
  class="trigger"
  (click)="openPicker()"
  [attr.aria-label]="'Active partner: ' + activeName() + ' — select to switch'"
>
  <ui-icon name="users" class="trigger__mark" />
  <span class="trigger__label body-sm strong">{{ activeName() }}</span>
  <ui-icon name="chevron-down" class="trigger__chevron" [strokeWidth]="1.5" />
</button>

<ui-modal size="md" [(open)]="open" heading="Select a partner">
  <ui-search-input class="picker__search" [tailIcon]="undefined">
    <input
      uiInput
      type="search"
      placeholder="Search…"
      aria-label="Search partners"
      [value]="query()"
      (input)="query.set($any($event.target).value)"
    />
  </ui-search-input>

  @if (data.partners.isLoading()) {
    <p class="body-md text-secondary">Loading partners…</p>
  } @else if (data.partners.error()) {
    <p class="body-md text-danger" role="alert">Couldn't load your partners. Please try again.</p>
  } @else {
    <ul class="picker__list">
      @for (partner of filtered(); track partner.id) {
        <li class="picker__item" [class.picker__item--active]="partner.id === activeId()">
          <div class="picker__meta">
            <span class="body-md strong">{{ partner.name }}</span>
            @if (partner.ownerEmail) {
              <span class="body-sm text-secondary">{{ partner.ownerEmail }}</span>
            }
          </div>
          @if (partner.id === activeId()) {
            <span class="picker__current body-sm strong">
              <ui-icon name="check" label="Current partner" [strokeWidth]="1.5" />
              Current
            </span>
          } @else {
            <button ui-button type="button" size="sm" (click)="select(partner)">Select</button>
          }
        </li>
      } @empty {
        <li class="picker__empty body-md text-secondary">No partners found.</li>
      }
    </ul>
  }
</ui-modal>
